import React from "react";
import PriceFormatter from "../../utils/PriceFormatter";

export const CurrencyCellRenderer = ({ value }) => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {/* <AttachMoneyIcon fontSize="small" /> */}
        {/* <span>RM</span>  */}
        {/* Malaysian Ringgit symbol */}
        <span style={{ marginLeft: "4px" }}>
          {" "}
          <PriceFormatter price={value} />
        </span>
      </div>
    );
  };
export const onHoldColumnHeader = 
//  (moreOptionsButton ) => 
    [
    {
      field: "id",
      filterable: false,
      headerName: "ID",
      flex: 0.5,
      hide: true,
      headerAlign: "left",
    },
    {
      field: "type",
      headerName: "TYPE",
      flex: 1.5,
      cellClassName: "bold-column--cell",
      headerAlign: "left",
    },
    {
      field: "payoutCycleCount",
      flex: 1,
      headerName: "CYCLES",
      headerAlign: "left",
    },
    {
      field: "dealerCount",
      flex: 1,
      headerName: "DEALERS",
      headerAlign: "left",
    },
    
    {
      field: "transactionTypeCount",
      headerName: "TRX TYPE",
      flex: 1,
      headerAlign: "left",
    },
    {
      field: "transactionCount",
      headerName: "# of TRX",
      flex: 1,
      headerAlign: "left",
    },
    {
      field: "totalPayoutAmount",
      headerName: "PAYOUT",
      flex: 1,
      headerAlign: "left",
      cellClassName: "bold-column--cell",
      renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
    }
     
    ];
    
    